<template>
    <div>
        <div class="custom-float-color form-group form-group--float form-group--centered">
            <input class="form-control" maxlength="6" placeholder="Input code" v-model="formData.two_factor_code" @input="showError = false">
            <template v-if="showError === true">
                <div class="custom-float-color form-group form-group--float form-group--centered">
                    <div class="alert alert-danger" role="alert">
                        {{errorMessage}}
                    </div>
                </div>
            </template>
        </div>
        <div class="checkbox custom-sm-label text-cf-light-green mb-2">
            <input type="checkbox" class="form-control" v-model="formData.remember_me" id="remember_me">
            <label class="checkbox__label custom-sm-checkbox-background" for="remember_me">Remember me for 30 days</label>
        </div>
        <button class="btn btn--icon login__block__btn bg-cf-light-green rebrand-login-button " @click="postAuthCode"><i :class="spinnerClass"></i></button>
    </div>
</template>

<script>
    export default {
        name: "TwoFactorAuth",
        data() {
            return {
                formData: {
                    two_factor_code: '',
                    remember_me: ''
                },
                showError: false,
                errorMessage: '',
                spinnerClass: "zmdi zmdi-check"
            }
        },
        methods: {
            postAuthCode() {
                this.showError = false;
                if(this.formData.two_factor_code.length !== 6) {
                    this.showError = true;
                    this.errorMessage = 'Invalid input, please ensure the code you have input is numerical and 6 digits.';
                    return;
                }
                let app = this;
                app.spinnerClass = "spinner-grow";
                axios.post('/verify', this.formData, {
                    headers:{
                        'Content-Type':'application/json',
                    }
                }).then(function(response) {
                    window.location.href = '/home'
                }).catch(error => {
                    app.spinnerClass = "zmdi zmdi-check";
                    if(error.response.data.errorMessage) {
                        this.errorMessage = error.response.data.errorMessage;
                    } else {
                        this.errorMessage = "An error occurred, if it occurs after trying again please call us on 0330 100 0330";
                    }
                    this.showError = true;
                });
            }
        }
    }
</script>

<style scoped>
    .custom-sm-label{
        font-size: 12px;
    }

    .checkbox__label::after {
        background-color: #78be20 !important;
    }
</style>